import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserLogin, userSignUp } from "../../../../../features/auth/authSlice";
import { getAllCart } from "../../../../../features/cart/cartSlice";
import { myAccount } from "../../../../../features/my_account/Slice";
import { text } from "@fortawesome/fontawesome-svg-core";
import SingUp_Modal from "./Singup_Modal";
import Success_Modal from "../../success_modal/Success_Modal";
import Black_Btn from "../../../common_btn/Black_Btn/Black_Btn";
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Login_Modal = (props) => {
  const {
    control,
    register,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm();

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const [showSignUp, setShowSignUp] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const [loder, setLoder] = useState(false);

  // const togglePasswordVisibility = (field) => {
  //   if (field === "password") {
  //     setShowPassword(!showPassword);
  //     setIconOne(showPassword ? faEyeSlash : faEye);
  //   } else if (field === "reenterPassword") {
  //     setShowPasswordOne(!showPasswordOne);
  //     setIconTwo(showPasswordOne ? faEyeSlash : faEye);
  //   }
  // };

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword((prev) => {
        setIconOne(prev ? faEyeSlash : faEye);
        return !prev;
      });
    }
  };

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);

  // const onLogin = async (data) => {
  //   // setLoder(true);
  //   const res = await dispatch(UserLogin(data));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     setLoder(false);
  //     await dispatch(myAccount());
  //     props?.onHide();
  //     props?.loginDone();
  //     setSuccessMsg("Login Succesfully !");
  //     setShowSucsessModal(true);
  //     setTimeout(() => {
  //       setShowSucsessModal(false);
  //       // navigate("/")
  //     }, 3000);
  //     dispatch(getAllCart(isSignin));
  //   } else if (res.meta?.requestStatus === "rejected") {
  //     setLoder(false);
  //     if (res.payload?.errors?.email) {
  //       setError("email", {
  //         type: "manual",
  //         message: res.payload?.errors?.email,
  //       });
  //     }
  //     if (res.payload?.errors?.email_or_contact) {
  //       setError("email_or_contact", {
  //         type: "manual",
  //         message: res.payload?.errors?.email_or_contact,
  //       });
  //     }
  //     if (res.payload?.errors?.password) {
  //       setError("password", {
  //         type: "manual",
  //         message: res.payload?.errors?.password,
  //       });
  //     }
  //   }
  // };

  //new
  const onLogin = async (data) => {
    let shouldShowLoader = true;

    try {
      // delay loader slightly to avoid flicker for fast errors
      const loaderTimeout = setTimeout(() => {
        if (shouldShowLoader) setLoder(true);
      }, 300); // 300ms delay

      const res = await dispatch(UserLogin(data));

      clearTimeout(loaderTimeout);

      if (res.meta?.requestStatus === "fulfilled") {
        setLoder(true); // show loader only for success flow

        await dispatch(myAccount());

        props?.onHide();
        props?.loginDone();

        setSuccessMsg("Login Successfull !");
        setShowSucsessModal(true);

        setTimeout(() => {
          setShowSucsessModal(false);
        }, 3000);

        dispatch(getAllCart());
      } else {
        shouldShowLoader = false;
        setLoder(false);

        // User not found
        if (res.payload?.errors?.email_or_contact) {
          setError("email_or_contact", {
            type: "manual",
            message: res.payload.errors.email_or_contact,
          });

          setError("password", {
            type: "manual",
            message: "Invalid Password",
          });
        }

        // Incorrect password
        if (res.payload?.errors?.password) {
          setError("password", {
            type: "manual",
            message: res.payload.errors.password,
          });
        }
      }
    } catch (err) {
      setLoder(false);
    } finally {
      shouldShowLoader = false;
      setLoder(false);
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);

  // useEffect(() => {
  //   if (user?.id) {
  //     dispatch(myAccount());
  //   }
  // }, []);

  useEffect(() => {
    if (!props.show) {
      reset(); // clear form
    }
  }, [props.show, reset]);

  return (
    <>
      <Modal className="Login_Modal" size="md" {...props} centered>
        <Modal.Header>
          <div className="logo_holder">
            <img src="/assets/images/logo/logo.png" className="logo_img" />
          </div>
          <div className="close_img_div">
            <img
              src="/assets/images/icons/close_white.png"
              className="close_img"
              onClick={() => {
                reset();
                props?.onHide();
              }}
            />
          </div>
        </Modal.Header>

        <Modal.Body>
          {!showSignUp && (
            <div className="login_div">
              <p className="modal_title_text">Log In</p>

              <div className="login_form_div">
                <Form>
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Email / Mobile Number</Form.Label>
                    {/* <Form.Control
                      type="text"
                      name="email_or_contact"
                      placeholder="Enter your email or mobile number"
                      {...register("email_or_contact", {
                        required: "Email is required",
                      })}
                    /> */}

                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter your email or mobile number"
                      maxLength={50} // for email safety
                      {...register("email_or_contact", {
                        required: "Email or Mobile number is required",
                        validate: (value) => {
                          const input = value.trim();

                          const isOnlyNumber = /^\d+$/.test(input);

                          if (isOnlyNumber) {
                            const isPhone = /^[6-9]\d{9}$/.test(input);
                            return (
                              isPhone || "Enter valid 10-digit Mobile Number"
                            );
                          }

                          const isEmail = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(
                            input,
                          );

                          return isEmail || "Enter valid Email Address";
                        },
                      })}
                      onInput={(e) => {
                        let value = e.target.value;

                        // If numeric → restrict to 10 digits
                        if (/^\d*$/.test(value)) {
                          e.target.value = value.slice(0, 10);
                        }
                      }}
                    />
                    {errors?.email_or_contact && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.email_or_contact?.message}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      autoComplete="new-password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                      style={{ paddingRight: "40px" }}
                    />

                    {/*Eye Icon */}
                    <span
                      className="password-toggle-icon"
                      onClick={() => togglePasswordVisibility("password")}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "38px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon icon={iconOne} />
                    </span>

                    {errors.password && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors.password.message}
                      </div>
                    )}
                    <p
                      className="link_text dark_text"
                      onClick={() => {
                        props?.onHide();
                        props?.setShowResetModal();
                      }}
                    >
                      Forgot Password?
                    </p>
                  </Form.Group>
                </Form>
              </div>

              <div className="bottom_div">
                {loder ? (
                  <>
                    <div className="text-center">
                      <ClipLoader />
                    </div>
                  </>
                ) : (
                  <div className="btn_holder">
                    <Black_Btn
                      btnText="Login"
                      onClick={handleSubmit(onLogin)}
                    />
                  </div>
                )}
                <p className="dark_text">
                  Don't have an account?{" "}
                  <span
                    className="link_text"
                    onClick={() => {
                      setShowSignUp(true);
                    }}
                  >
                    Create Account
                  </span>
                  .
                </p>
              </div>
            </div>
          )}

          {showSignUp && (
            <SingUp_Modal
              setShowSignUp={setShowSignUp}
              showSignUp={showSignUp}
              setShowAccountCreted={props?.setShowAccountCreted}
              onHide={props?.onHide}
            />
          )}
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText={successMsg}
      />
    </>
  );
};

export default Login_Modal;
